import { useContext } from 'react';
import TestDetailContext from 'business/organizer/assessment/contexts/test-detail/TestDetailContext';

const useTestDetail = (): ITestDetailContext => {
  return useContext(TestDetailContext) as ITestDetailContext;
};

export default useTestDetail;
